/* LMC Orlando — Contact page (Chunk 15).

   <lmc-topic-chips> wraps a row of <label class="lmc-topic-chip"> elements,
   each containing a hidden radio input. Clicking a label syncs the radio
   + flips the .is-active class. Only one chip can be active at a time.

   Loaded only on the contact template from layout/theme.liquid. */

(function () {
  'use strict';

  class LMCTopicChips extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('.lmc-topic-chip'));
      this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
      this.inputs.forEach((input) => input.addEventListener('change', this.onChange));
      this.syncActive();
    }

    disconnectedCallback() {
      this.inputs?.forEach((input) => input.removeEventListener('change', this.onChange));
    }

    onChange() {
      this.syncActive();
    }

    syncActive() {
      this.chips.forEach((chip) => {
        const input = chip.querySelector('input[type="radio"]');
        chip.classList.toggle('is-active', !!(input && input.checked));
      });
    }
  }

  if (!customElements.get('lmc-topic-chips')) {
    customElements.define('lmc-topic-chips', LMCTopicChips);
  }
})();
